
import {Options, Vue} from 'vue-class-component';
import {Button, Checkbox, TextButton, TextInput} from "@timenaut/timenaut-vue-common"
import axios from 'axios';
import ArrowRight from "@timenaut/timenaut-vue-common/lib/assets/icons/feather/arrow-right.svg"
import {router} from "@/router";

@Options({
  components: {
    TextInput,
    Button,
    TextButton,
    Checkbox,
    ArrowRight,
  },
})
export default class extends Vue {
  password: string = "";
  password2: string = "";

  passwordError: string = "";

  async reset() {
    this.passwordError = "";

    console.log()

    if (this.password !== this.password2) {
      this.passwordError = "Passwords do not match";
      return;
    }

    if (this.password.length < 8) {
      this.passwordError = "Password must be longer than 8 characters";
      return;
    }

    axios.post(process.env.VUE_APP_API_URL + "/auth/reset", {
      password: this.password,
      resetCode: this.$route.hash,
    })
        .then(() => {
          router.push("/login");
        })
        .catch(() => {
          this.passwordError = "Unexpected error occurred"
        })
  }
}
